import React from 'react';
import { themr } from 'react-css-themr';
import { translate } from 'react-i18next';
import ButtonWithPopover from 'common/components/core/button/ButtonWithPopover';
import { ButtonTypes } from 'common/components/core/button/Button';
import { FilterList } from 'common/components/core/filter/FilterList';
import theme from './LocationFilterPopoverButton.scss';
import {
    PopoverPlaceEnum,
    PopoverTriggerEnum
} from 'common/components/core/popover/popOverFactory';

class LocationFilterPopoverButton extends React.PureComponent {
    getAppliedFiltersCount = () => {
        const { appliedFilters } = this.props;
        return Object.keys(appliedFilters)
            .map(appliedFilterKey => {
                return appliedFilters[appliedFilterKey].isFilterApplied
                    ? true
                    : false;
            })
            .filter(Boolean).length;
    };

    handleFilterChange = appliedFilters => {
        const { onFilterChange } = this.props;
        onFilterChange && onFilterChange(appliedFilters);
    };

    renderFilters(appliedFiltersCount) {
        const { filters, appliedFilters, theme, t } = this.props;
        return (
            <FilterList
                theme={theme}
                filters={filters}
                appliedFilters={appliedFilters}
                title={t('geocodeMap.locationFilters', {
                    appliedFiltersCount
                })}
                onChange={this.handleFilterChange}
            />
        );
    }

    render() {
        const { theme } = this.props;
        const appliedFiltersCount = this.getAppliedFiltersCount();

        return (
            <ButtonWithPopover
                inverted
                countLabelButton
                label={appliedFiltersCount}
                buttonType={ButtonTypes.Icon}
                icon="filter"
                theme={theme}
                triggerPopoverOn={PopoverTriggerEnum.Click}
                ripple={false}
                className={theme.filterButton}
                popOverClassName={theme.filterPopover}
                invertPopover={false}
                preferPlace={PopoverPlaceEnum.Below}
                popOverContent={this.renderFilters(appliedFiltersCount)}
            />
        );
    }
}
const ThemedLocationFilterPopoverButton = translate()(
    themr('LocationFilterPopoverButton', theme)(LocationFilterPopoverButton)
);
export { ThemedLocationFilterPopoverButton as LocationFilterPopoverButton };
export default ThemedLocationFilterPopoverButton;
